/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Contactsettings1Inputs */

const en_entity_contactsettings1 = /** @type {(inputs: Entity_Contactsettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Settings`)
};

const de_entity_contactsettings1 = /** @type {(inputs: Entity_Contactsettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt-Einstellungen`)
};

/**
* | output |
* | --- |
* | "Contact Settings" |
*
* @param {Entity_Contactsettings1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_contactsettings1 = /** @type {((inputs?: Entity_Contactsettings1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Contactsettings1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_contactsettings1(inputs)
	return de_entity_contactsettings1(inputs)
});
export { entity_contactsettings1 as "entity_contactSettings" }